module.exports = __webpack_public_path__ + "img/deposit-under.75bddab8.svg";